var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3889 24.6181L7.95139 21.6319L1.73611 24.0972C1.34259 24.3056 0.954861 24.294 0.572917 24.0625C0.190972 23.831 0 23.4838 0 23.0208V3.64583C0 3.34491 0.0868056 3.0787 0.260417 2.84722C0.434028 2.61574 0.659722 2.44213 0.9375 2.32639L7.25694 0.104167C7.48843 0.0347222 7.71991 0 7.95139 0C8.18287 0 8.41435 0.0347222 8.64583 0.104167L17.0833 3.05556L23.2639 0.590278C23.6574 0.405093 24.0451 0.422454 24.4271 0.642361C24.809 0.862269 25 1.2037 25 1.66667V21.2847C25 21.5394 24.9132 21.7593 24.7396 21.9444C24.566 22.1296 24.3519 22.2685 24.0972 22.3611L17.7778 24.6181C17.5463 24.6875 17.3148 24.7222 17.0833 24.7222C16.8519 24.7222 16.6204 24.6875 16.3889 24.6181ZM15.9028 22.2569V4.72222L9.09722 2.43056V19.9653L15.9028 22.2569ZM17.9861 22.2569L22.9167 20.625V2.84722L17.9861 4.72222V22.2569ZM2.08333 21.8403L7.01389 19.9653V2.43056L2.08333 4.0625V21.8403Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap40);
export default __webpack_public_path__ + "static/media/map40.c034a2e9955d673104f3f89cb736b3d2.svg";
export { ForwardRef as ReactComponent };